import React, { Component } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { ProductConsumer } from "../context";
import PropTypes from "prop-types";
import { FaShoppingCart } from "react-icons/fa";
import { MdRemoveShoppingCart } from "react-icons/md";

class Product extends Component {
  render() {
    const { id, title, img, price, inCart } = this.props.product;
    return (
      <ProductWrapper className="col-9 mx-auto col-md-6 col-lg-3">
        <div className="card" style={{ marginBottom: "1rem" }}>
          <ProductConsumer>
            {(value) => (
              <div
                className="img-container p-5"
                onClick={() => value.handleDetail(id)}
              >
                <Link to="/details">
                  <img
                    src={img}
                    alt="productImg"
                    className="card-img-top"
                    style={{ height: "10rem" }}
                  />
                </Link>
                <button
                  style={{
                    width: "4rem",
                    backgroundColor: "#3094FF",
                    height: "2rem",
                  }}
                  className="cart-btn"
                  disabled={inCart ? true : false}
                  onClick={() => {
                    value.addToCart(id);
                    value.openModal(id);
                  }}
                >
                  {inCart ? (
                    <p
                      type="button"
                      className="text-capitalize mb-0"
                      disabled
                      style={{ fontSize: "0.8rem" }}
                    >
                      ALready in cart <br />
                      <MdRemoveShoppingCart />
                    </p>
                  ) : (
                    <div>
                      +<FaShoppingCart />
                    </div>
                  )}
                </button>
              </div>
            )}
          </ProductConsumer>

          <div
            className="card-footer d-flex justify-content-between"
            style={{ marginBottom: "1rem" }}
          >
            <p className="align-self-center mb-o">{title}</p>
            <h5 className="mb-o">
              <strong>
                <span style={{fontSize:"16px"}} className="mr-1">Ksh. {price}</span>
              </strong>
            </h5>
          </div>
        </div>
      </ProductWrapper>
    );
  }
}
export default Product;

Product.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.number,
    img: PropTypes.string,
    title: PropTypes.string,
    price: PropTypes.number,
    inCart: PropTypes.bool,
  }).isRequired,
};

const ProductWrapper = styled.div`
.card{
    border-color:transparent;
    transition:all 1s linear;
    box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.2);
    height: 20rem
}

.card-footer{
    background: transparent;
    border-top: transparent;
    transition: all 1s linear;
    background: rgba(247, 247, 247)
}
&:hover{
    .card{
        border: 0.04 rem solid rgba(0,0,0,0.2)
        box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.2)
    }
    .card-footer{
        background: rgba(247, 247, 247)
    }
}
.img-container{
  position:relative;
  overflow: hidden;
}
.card-img-top{
  transition: all 1s linear;
}
.img-container:hover .card-img-top{
  transform:scale(1.1);
}
.cart-btn{
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 0.2rem 0.2rem;
  background: #3094FF;
  border: none;
  color: white;
  font-size: 1.4rem;
  border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
  transform:translate(100%, 100%);
  transition: all 0.8s linear;
}

.img-container:hover .cart-btn{
  transform: translate(0,0);
}

`;
